function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 24c-3.005 1.786-6 2-9 0-6.867 16.268-12 21-20 28h49c-8-7-13-12-20-28zM47 10.5c0 4.142-4.922 6.385-12.086 5.9C29 16 28 24 28 24s-7-6-7-11.443C21 6 26.82 3 34 3s13 3.358 13 7.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43.5,
  cy: 18.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 8.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 26.5,
  r: 0.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.8 29c-.402 1.97-.8 1-1.8 7l5-6 3.581 7.562L32 30s3 4 5 6l-1.7-7"
}));

var SvgVolcano = function SvgVolcano(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolcano, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Volcano.15325697.svg";
export { ForwardRef as ReactComponent };